import { Selector } from '@ngxs/store';
import type { SettingsStateModel } from 'commons';
import { SettingsState } from './settings.state';

export class SettingsSelector {
  // ███████╗███████╗██╗     ███████╗ ██████╗████████╗ ██████╗ ██████╗
  // ██╔════╝██╔════╝██║     ██╔════╝██╔════╝╚══██╔══╝██╔═══██╗██╔══██╗
  // ███████╗█████╗  ██║     █████╗  ██║        ██║   ██║   ██║██████╔╝
  // ╚════██║██╔══╝  ██║     ██╔══╝  ██║        ██║   ██║   ██║██╔══██╗
  // ███████║███████╗███████╗███████╗╚██████╗   ██║   ╚██████╔╝██║  ██║
  // ╚══════╝╚══════╝╚══════╝╚══════╝ ╚═════╝   ╚═╝    ╚═════╝ ╚═╝  ╚═╝
  //

  /**
   *
   * @param state
   * @returns
   */
  @Selector([SettingsState]) static filterPanelVisibility(state: SettingsStateModel) {
    return state?.filterPanelVisibility && !state.databrowserIsCollapsed;
  }
  /**
   *
   * @param state
   * @returns
   */
  @Selector([SettingsState]) static getDatabrowserCollapsedState(state: SettingsStateModel) {
    return state?.databrowserIsCollapsed;
  }
  /**
   *
   * @param state
   * @returns
   */
  @Selector([SettingsState]) static getSearch(state: SettingsStateModel) {
    return state.search ?? '';
  }
  /**
   *
   */
  @Selector([SettingsState]) static getPollingInterval(state: SettingsStateModel) {
    return state.pollingInterval;
  }
  /**
   *
   * @param state
   * @returns
   */
  @Selector([SettingsState]) static getAutofreshEnabled(state: SettingsStateModel) {
    return state.enabledAutoFresh;
  }
  /**
   *
   * @param state
   * @returns
   */
  @Selector([SettingsState])
  static getDebugMode(state: SettingsStateModel) {
    return state.debug;
  }
}
